module.exports = __webpack_public_path__ + "static/p2r-logo-d25d582effc4525c6d0644ac4f801032.png";